import { cn } from "@/utils/cn";
import { FruitInfoIconButton } from "./fruit-info-icon-button";
import { MealTitle } from "./meal-title";

interface FruitContentProps {
  mealName: string;
  /** When true, renders the ticked-off "done" style (My Plan v2). */
  isDone?: boolean;
}

export const FruitContent = ({ mealName, isDone = false }: FruitContentProps) => {
  return (
    <div className={cn("flex items-center gap-2", isDone && "opacity-50")}>
      <MealTitle
        title={mealName}
        className={cn("flex-1", isDone && "line-through decoration-solid")}
      />
      <FruitInfoIconButton />
    </div>
  );
};
